import { filtersHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';

export const orientationModuleAssignmentModel = (data) => ({
    uuid: data.uuid,
    startDate: data.start_date,
    endDate: data.end_date,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    header: data.header ? {
        uuid: data.header.uuid,
        name: data.header.name,
        usageType: data.header.usage_type,
    } : null,
    user: data.user ? (userModel(data.user)) : null,
});